import type { DragLocationHistory } from '@atlaskit/pragmatic-drag-and-drop/types';
import type { ResizeBounds } from './types';

export const getProposedWidth = ({
	initialWidth,
	location,
	resizeBounds,
	direction,
}: {
	initialWidth: number;
	location: DragLocationHistory;
	resizeBounds: ResizeBounds;
	direction: 'ltr' | 'rtl';
}): number => {
	const diffX = location.current.input.clientX - location.initial.input.clientX;
	const proposedWidth = direction === 'rtl' ? initialWidth - diffX : initialWidth + diffX;

	// Ensure we don't go below the min or above the max allowed widths
	return Math.min(Math.max(resizeBounds.min, proposedWidth), resizeBounds.max);
};
